import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button, List, ListItem, Stack } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { TemplateSetAggregate } from "../../services/api/TemplateSets";
import { DefaultContentCell, DefaultHeaderCell, StripedTableRow } from "../../theme";
import TemplateSetRowAction from "./TemplateSetRowAction";

const TemplateSetsTable: React.FC<{ templateSets: TemplateSetAggregate[] }> = ({ templateSets }) => {
  const navigate = useNavigate();

  return (
    <>
      <Stack direction="row" sx={{ padding: "3px" }} alignItems="right" justifyContent="flex-end">
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            navigate("/template-sets/create");
          }}
        >
          Add New Set
        </Button>
      </Stack>
      <TableContainer sx={{ marginTop: "10px" }}>
        <Table>
          <TableHead>
            <TableRow>
              <DefaultHeaderCell sx={{ minWidth: 80 }}>ID</DefaultHeaderCell>
              <DefaultHeaderCell sx={{ minWidth: 250 }}>Name</DefaultHeaderCell>
              <DefaultHeaderCell sx={{ minWidth: 250 }}>Mapped Templates</DefaultHeaderCell>
              <DefaultHeaderCell>Action</DefaultHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templateSets.map((ts) => (
              <StripedTableRow key={ts.name}>
                <DefaultContentCell>{ts.id}</DefaultContentCell>
                <DefaultContentCell>{ts.name}</DefaultContentCell>
                <DefaultContentCell>
                  <List>
                    {ts.templates?.map((t, i) => (
                      <ListItem key={i} dense disableGutters>
                        <Link to={`/templates/${t.name}`}>{t.name}</Link>
                      </ListItem>
                    ))}
                  </List>
                </DefaultContentCell>
                <DefaultContentCell>
                  <TemplateSetRowAction templateSetAggregate={ts} />
                </DefaultContentCell>
              </StripedTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TemplateSetsTable;
